import axios from "axios";

// ✅ Create axios instance
const API_BASE_URL =
process.env.REACT_APP_MAAZ_API_URL || "http://localhost:5000/api";

export const API_ORIGIN = new URL(API_BASE_URL).origin;

const api = axios.create({
baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ REQUEST INTERCEPTOR
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      // 🔥 ensure headers exists
      if (!config.headers) {
        config.headers = {};
      }

      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// ✅ RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);

    const isSsoExchange =
      error?.config?.url?.includes("/sso/exchange");

    if (error.response && error.response.status === 401 && !isSsoExchange) {
      console.warn("🔒 Unauthorized → redirecting to login");

      localStorage.removeItem("token");
      localStorage.removeItem("student");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);

export default api;
